import React from "react";
import "./ScheduleMeetingButton.module.css";

const ScheduleMeetingButton = () => {
  return (
    <a
      href="https://o1sa40rge2x.typeform.com/to/hipnkX45"
      target="_blank"
      rel="noopener noreferrer"
    >
      <button
        className="scheduleButton"
      >
        Schedule a Meeting
      </button>
    </a>
  );
};

export default ScheduleMeetingButton;



// WEBPACK FOOTER //
// ./src/components/Header/components/ScheduleMeetingButton/ScheduleMeetingButton.js